@if(isOpen()){
<div
  class="fixed top-30 right-10 text-xl font-bold animate-[slide-in-left_0.3s_ease-out]"
  cdkDrag
>
  <div
    class="relative max-w-[10rem] text-[0.875rem]/[1.375rem] p-3 rounded-xl flex flex-col gap-3 items-center bg-white shadow-xl"
  >
    <button
      class="absolute top-1 right-2 self-end hover:cursor-pointer"
      type="button"
      (click)="close()"
    >
      <icon [name]="'cancel'" [size]="'0.5rem'" />
    </button>
    <p class="mt-2">{{ 'components.feedbackPopin.text' | transloco }}</p>
    <div class="flex gap-[0.375rem]">
      @for (ratingOption of ratingButtons(); track $index) {
      <button
        class="hover:cursor-pointer"
        type="button"
        (click)="setRating(ratingOption)"
        [attr.aria-label]="'Note ' + ratingOption"
      >
        <icon
          [name]="'star'"
          [size]="'0.875rem'"
          [color]="ratingOption <= rating() ? 'text-vinciGolden' : 'text-vinciGrey-200'"
        ></icon>
      </button>
      }
    </div>
    <app-button
      [text]="'components.feedbackPopin.buttonText' | transloco"
      [variant]="'secondary'"
      [size]="'sm'"
      (buttonClick)="redirectToFeedback()"
      class="w-full"
    />
  </div>
</div>
}
